exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.remove {\n  color: #fff;\n  font-size: 12px;\n  line-height: 12px;\n}", ""]);

// exports
